import React from 'react';

import 'react-responsive-modal/styles.css';

import './LoginPage.scss' ;

import {createRoot} from "react-dom/client";
import LoginForm from "root/Login/LoginForm";

import {getLoginParams} from "@estar/SystemConstants";

const MyLoginPage = ({dataset}) =>
{
    const loginParams = getLoginParams(dataset.authority_id);

    return (
        <LoginForm params={loginParams} mode={dataset.action} redirect={dataset.redirect} logoutreason={dataset.logoutreason} reason={dataset.reason} establishment_number={dataset.establishment_number} defaultLogo={dataset.logo_url} variant_type={dataset.variant_type} username={dataset.username} token={dataset.token} authority_id={dataset.authority_id}/>
    )
}

const container = document.getElementById('app');

const atts = container.dataset;

const root = createRoot(container);
root.render(<MyLoginPage dataset={atts}/>);
